var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso6Green(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 132.8",
    style: {
      enableBackground: "new 0 0 143 132.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#639540;stroke-width:6.01;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000099633250735386958670000014763465161173299640_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1189",
    className: "st0",
    d: "M72.1,85.4L72.1,85.4c7.9,0,14.4,6.4,14.4,14.4v5.2c0,7.9-6.4,14.4-14.4,14.4l0,0 c-8,0-14.4-6.4-14.4-14.4c0,0,0,0,0,0v-5.2C57.7,91.8,64.1,85.4,72.1,85.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_131",
    className: "st0",
    cx: 72.1,
    cy: 75.2,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_467",
    className: "st0",
    d: "M140,44.4v63.4c0.4,11.7-8.8,21.6-20.5,22h-96C11.8,129.4,2.6,119.6,3,107.9V44.4 c-0.2-4.8,3.6-8.8,8.4-9h18.3c4.8,0.2,8.6,4.2,8.4,9l0,0v51.5c-0.2,4.8,3.6,8.8,8.4,9h53.1c4.8-0.2,8.6-4.2,8.4-9l0,0V44.4 c-0.2-4.8,3.6-8.8,8.4-9h15.1C136.3,35.6,140.1,39.6,140,44.4L140,44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1190",
    className: "st0",
    d: "M15,3h3.2c6.6,0,12,5.4,12,12v24.6c0,6.6-5.4,12-12,12H15c-6.6,0-12-5.4-12-12V15 C3,8.4,8.4,3,15,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1191",
    className: "st0",
    d: "M42.2,3h3.2c6.6,0,12,5.4,12,12v24.6c0,6.6-5.4,12-12,12h-3.2c-6.6,0-12-5.4-12-12V15 C30.2,8.4,35.6,3,42.2,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1192",
    className: "st0",
    d: "M69.4,3h3.2c6.6,0,12,5.4,12,12v24.6c0,6.6-5.4,12-12,12h-3.2c-6.6,0-12-5.4-12-12V15 C57.4,8.4,62.8,3,69.4,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1193",
    className: "st0",
    d: "M97.6,3h3.2c6.6,0,12,5.4,12,12v24.6c0,6.6-5.4,12-12,12h-3.2c-6.6,0-12-5.4-12-12V15 C85.5,8.4,90.9,3,97.6,3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1194",
    className: "st0",
    d: "M124.8,3h3.2c6.6,0,12,5.4,12,12v24.6c0,6.6-5.4,12-12,12h-3.2c-6.6,0-12-5.4-12-12V15 C112.8,8.4,118.1,3,124.8,3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso6Green);
export default __webpack_public_path__ + "static/media/Recurso 6green.4391fe60667c5c5f1a85c4ecb4514a31.svg";
export { ForwardRef as ReactComponent };